import ScalarComboboxPopover_vue_vue_type_script_setup_true_lang_default from "./ScalarComboboxPopover.vue.script.js";
//#region src/components/ScalarCombobox/ScalarComboboxPopover.vue
var ScalarComboboxPopover_default = ScalarComboboxPopover_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarComboboxPopover_default as default };

//# sourceMappingURL=ScalarComboboxPopover.vue.js.map